import React from "react";

/**
 * Compact grip selector — pill rows with grip number, name and tagline.
 * Used on the Product detail page and the Quick-add dialog.
 */
const GripSelector = ({ grips = [], value, onChange, testIdPrefix = "grip" }) => {
  if (!grips.length) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" data-testid={`${testIdPrefix}-selector`}>
      {grips.map((g) => {
        const active = value === g.slug;
        return (
          <button
            key={g.slug}
            type="button"
            onClick={() => onChange(g.slug)}
            className={`border p-3 text-left transition-colors ${
              active
                ? "bg-ink text-white border-ink"
                : "bg-white text-ink border-line hover:border-ink"
            }`}
            data-testid={`${testIdPrefix}-${g.slug}`}
          >
            <p className={`mono text-[10px] ${active ? "text-white/70" : "text-mute"}`}>{g.no}</p>
            <p className="mt-1 text-[11px] tracking-widest uppercase font-bold leading-tight">{g.name}</p>
            <p className={`mt-1 text-[10px] leading-snug ${active ? "text-white/70" : "text-mute"}`}>
              {g.tagline}
            </p>
          </button>
        );
      })}
    </div>
  );
};

export default GripSelector;
